export default __webpack_public_path__ + "static/media/Roboto-Medium.d2d7f0c0.ttf";